import { Routes } from '@angular/router';

import { AccueilComponent } from './accueil/accueil.component';

import { PageComponent } from './page/page.component';
import { PermissionDeniedComponent } from './del-common/components/permission-denied/permission-denied.component';
import { StatistiquesComponent } from './statistiques/statistiques.component';
import {FeedbackComponent} from './common/components/feedback/feedback.component';


export const ROUTES: Routes = [
  { path: '', component: AccueilComponent },
  { path: 'page/:id', component: PageComponent},
  { path: 'feedback', component: FeedbackComponent},
  { path: 'statistiques', component: StatistiquesComponent},
  { path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)},
  { path: 'settings', loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule)},
  /*{ path: '',
    children: [{
      path: 'admin',
      loadChildren: './admin/admin.module#AdminModule',
      canActivate: [AdminGuardService],
      canLoad: [AdminGuardService]
    }]
  },*/
  { path: 'forbidden', component: PermissionDeniedComponent},
];

